import { useQuery } from "react-query";
import { http } from "src/api/http";
import { MyContentSong } from "./models";

export function useMyContentSongs() {
  return useQuery<MyContentSong[]>({
    queryKey: ["useMyContentSongs"],
    queryFn: () => http(`/api/my-content/songs`)
  });
}